import styled from 'styled-components';

export const Container = styled.div`
  &.group-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;

    width: 100%;
    min-height: 290px;

    .button {
      margin-top: auto;
    }

    animation: entering 0.5s ease-in;
  }
`;
